module.exports = __webpack_public_path__ + "static/simple-histogram-1e2363ff59d34bff302da9f1c15ab312.png";